import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  forwardRef
} from '@angular/core';

import {
  ControlValueAccessor,
  NG_VALUE_ACCESSOR
} from '@angular/forms';

@Directive({
  selector: '[percentMask]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PercentMaskDirective),
      multi: true
    }
  ]
})
export class PercentMaskDirective
  implements ControlValueAccessor {

  // NOVO
  @Input() showPercentSymbol = true;

  private onChange = (value: number | null) => { };
  private onTouched = () => { };

  constructor(
    private el: ElementRef<HTMLInputElement>
  ) { }

  writeValue(value: number | null): void {

    if (value === null || value === undefined) {
      this.el.nativeElement.value = '';
      return;
    }

    this.el.nativeElement.value =
      this.format(value);
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  @HostListener('input', ['$event'])
  onInput(event: any): void {

    const input = this.el.nativeElement;

    // remove tudo que não for número
    let numbers = input.value.replace(/\D/g, '');

    if (!numbers) {
      numbers = '0';
    }

    // converte para centavos
    const numeric = Number(numbers) / 100;

    // formata visual
    const formatted =
      numeric
        .toFixed(2)
        .replace('.', ',');

    input.value = this.showPercentSymbol
      ? `${formatted}%`
      : formatted;

    // move cursor para final
    setTimeout(() => {
      input.selectionStart = input.selectionEnd =
        input.value.length;
    });

    // model
    this.onChange(numeric / 100);
  }

  @HostListener('blur')
  onBlur(): void {
    this.onTouched();
  }

  private cleanValue(value: string): string {

    return value
      .replace('%', '')
      .replace(',', '.')
      .trim();
  }

  private format(value: number): string {

    const formatted =
      (value * 100)
        .toFixed(2)
        .replace('.', ',');

    return this.showPercentSymbol
      ? `${formatted}%`
      : formatted;
  }
}